import { useEffect } from "react";

const BASE = "https://hllpxyz.cn";

function setMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

type SeoProps = {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  jsonLd?: object[];
};

export default function Seo({ title, description, keywords, path, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setLink("canonical", `${BASE}${path}`);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${BASE}${path}`);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    const container = document.getElementById("page-jsonld");
    if (container) container.remove();
    if (jsonLd && jsonLd.length) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      const c = document.getElementById("page-jsonld");
      if (c) c.remove();
    };
  }, [title, description, keywords, path]);

  return null;
}